/* Which locale a blog post belongs to, and where its translation lives.

   A post's language is carried by its slug, not by the URL it was
   reached at: Spanish posts are `es-<english slug>` and live under /es,
   English posts have no prefix. BlogPost.jsx resolves any slug under
   either prefix, so /blog/es-foo renders the Spanish post too — which is
   why the canonical and hreflang are derived from the slug here rather
   than from location.pathname.

   Shared by BlogPost.jsx (Helmet) and scripts/prerender.cjs (static
   HTML) so the head a crawler reads and the head React writes agree. */

const SITE = 'https://jamaklab.com';
const SPANISH_PREFIX = 'es-';

export const isSpanishPost = (slug) => slug.startsWith(SPANISH_PREFIX);

/* The same post's path in the other language, worked out from the slug
   alone, for the EN|ES switcher: a bare prefix swap would turn
   /blog/foo into /es/blog/foo, the English post under a Spanish URL.
   Whether the translation exists is BlogPost.jsx's call. Returns null
   for anything that is not a post path. */
const POST_PATH = /^(?:\/es)?\/blog\/([^/]+)\/?$/;
export function blogPostPathIn(pathname, lang) {
  const match = pathname.match(POST_PATH);
  if (!match) return null;
  const english = match[1].replace(/^es-/, '');
  return lang === 'es' ? `/es/blog/${SPANISH_PREFIX}${english}` : `/blog/${english}`;
}

export const blogPostUrl = (slug) =>
  `${SITE}${isSpanishPost(slug) ? '/es' : ''}/blog/${slug}`;

/* hreflang must be reciprocal, so a pair is emitted only when both
   posts exist. A post with no translation gets no alternates at all:
   pointing `es` at /es/blog/<english slug> would declare the English
   article to be its own Spanish version. */
export function blogPostAlternates(slug, allSlugs) {
  const english = isSpanishPost(slug) ? slug.slice(SPANISH_PREFIX.length) : slug;
  const spanish = `${SPANISH_PREFIX}${english}`;
  if (!allSlugs.includes(english) || !allSlugs.includes(spanish)) return [];
  return [
    { hreflang: 'en', href: blogPostUrl(english) },
    { hreflang: 'es', href: blogPostUrl(spanish) },
    { hreflang: 'x-default', href: blogPostUrl(english) }
  ];
}
